import React from 'react';
import PropTypes from "prop-types";
export var EuiHeaderSectionsProp = () => <div />;
EuiHeaderSectionsProp.propTypes = {
  /**
     * An arry of items that will be wrapped in a #EuiHeaderSectionItem
     */
  items: PropTypes.arrayOf(PropTypes.node.isRequired),

  /**
     * Apply the passed border side to each #EuiHeaderSectionItem
     */
  borders: PropTypes.oneOf(["left", "right", "none"]),

  /**
     * Breadcrumbs in the header cannot be wrapped in a #EuiHeaderSection in order for truncation to work.
     * Simply pass the array of Breadcrumb objects
     */
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string,
    "aria-label": PropTypes.string,
    "data-test-subj": PropTypes.string,
    text: PropTypes.node.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func,
    truncate: PropTypes.bool
  }).isRequired),

  /**
     * Other props to pass to #EuiHeaderBreadcrumbs
     */
  breadcrumbProps: PropTypes.any
};

try {
  // @ts-ignore
  EuiHeaderSectionsProp.displayName = "EuiHeaderSectionsProp"; // @ts-ignore

  EuiHeaderSectionsProp.__docgenInfo = {
    "description": "",
    "displayName": "EuiHeaderSectionsProp",
    "props": {
      "items": {
        "defaultValue": null,
        "description": "An arry of items that will be wrapped in a #EuiHeaderSectionItem",
        "name": "items",
        "required": false,
        "type": {
          "name": "ReactNode[] | undefined"
        }
      },
      "borders": {
        "defaultValue": null,
        "description": "Apply the passed border side to each #EuiHeaderSectionItem",
        "name": "borders",
        "required": false,
        "type": {
          "name": "\"none\" | \"left\" | \"right\" | undefined"
        }
      },
      "breadcrumbs": {
        "defaultValue": null,
        "description": "Breadcrumbs in the header cannot be wrapped in a #EuiHeaderSection in order for truncation to work.\nSimply pass the array of Breadcrumb objects",
        "name": "breadcrumbs",
        "required": false,
        "type": {
          "name": "Breadcrumb[] | undefined"
        }
      },
      "breadcrumbProps": {
        "defaultValue": null,
        "description": "Other props to pass to #EuiHeaderBreadcrumbs",
        "name": "breadcrumbProps",
        "required": false,
        "type": {
          "name": "Pick<EuiBreadcrumbsProps, \"className\" | \"aria-label\" | \"data-test-subj\" | \"max\" | \"responsive\" | \"truncate\" | \"showMaxPopover\"> | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src-docs/src/views/header/props.tsx#EuiHeaderSectionsProp"] = {
      docgenInfo: EuiHeaderSectionsProp.__docgenInfo,
      name: "EuiHeaderSectionsProp",
      path: "src-docs/src/views/header/props.tsx#EuiHeaderSectionsProp"
    };
} catch (__react_docgen_typescript_loader_error) {}